// navigator.clipboard so existe em contexto seguro (HTTPS ou localhost). Em HTTP puro (ex.: ambiente de
// desenvolvimento acessado por IP) ele e undefined; nesse caso usa o metodo antigo (execCommand).
function copyWithTextarea(text) {
  const area = document.createElement('textarea');
  area.value = text;
  area.setAttribute('readonly', '');
  area.style.position = 'fixed';
  area.style.top = '0';
  area.style.left = '-9999px';
  area.style.opacity = '0';
  document.body.appendChild(area);
  try {
    area.select();
    area.setSelectionRange(0, text.length);
    return document.execCommand('copy');
  } catch (error) {
    return false;
  } finally {
    document.body.removeChild(area);
  }
}

/** Copia o texto para a area de transferencia. Devolve true se copiou, false se o navegador recusou. */
export default async function copyToClipboard(text) {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (error) {
      // permissao negada ou documento sem foco: tenta o plano B
    }
  }
  return copyWithTextarea(text);
}
